module.exports = {"TXTCLI_Required":{"id":"TXTCLI_Required","defaultMessage":"Requis","track":"Required"}}